import { useMemo } from 'react'

import { Button } from 'core-components/library/button'
import { Checkbox } from 'core-components/library/checkbox'
import { Flex } from 'core-components/library/flex'
import { Input } from 'core-components/library/inputs'
import { MultiSelect } from 'core-components/library/multiSelect'
import { NotificationController } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'
import { isEmpty, ValidateInput } from 'core-components/library/validation'
import { IBaseSettings } from 'core-components/sitebuilder/settings/models/IBaseSettings'
import { BaseCrud, Static } from 'core-components/types'

import { GroupSelector } from './basicSettings/GroupSelector'
import { WidgetIconButton } from './basicSettings/WidgetIconButton'

export const BasicSettings = ({
  onChangeField,
  widget,
  renderCustomSettingsWidget,
  roles,
}: IBaseSettings) => {
  const rolesCrud = useMemo(() => {
    return new BaseCrud({
      fetcher: new Static(
        roles.map((item) => {
          return { value: item.id, label: item.title }
        })
      ),
      defaultPaging: {
        page: 0,
        pageSize: 1000,
      },
      keyField: 'value',
    })
  }, [roles])

  const iconRender = useMemo(() => {
    return (
      <Flex flexShrink={0}>
        <WidgetIconButton iconClass={widget.iconClass} onChangeField={onChangeField} />

        <Tooltip tipContent={() => <div>Copy</div>}>
          <Button
            iconButton={'kbase kbase-copy'}
            color={'grey'}
            disabled={widget.isNew}
            onClick={async () => {
              await navigator.clipboard.writeText(widget.i)
              NotificationController.showSuccess({ message: 'Copied!' })
            }}
          />
        </Tooltip>
      </Flex>
    )
  }, [widget, onChangeField])

  return (
    <Flex flexDirection={'column'}>
      <Flex>
        <ValidateInput
          checkFn={isEmpty}
          classes={{ validatorClasses: { root: 'content-full-width' } }}
          disabled={!widget.isNew}
          label="ViewModel"
          value={widget.i}
          onChange={(value: string) => onChangeField('i', value)}
        />

        {iconRender}
      </Flex>
      <Flex>
        <ValidateInput
          checkFn={isEmpty}
          classes={{ validatorClasses: { root: 'content-full-width' } }}
          label="Title"
          value={widget.title}
          onChange={(value: string) => onChangeField('title', value)}
        />

        <GroupSelector
          value={widget.group || ''}
          onChange={(value) => onChangeField('group', value)}
        />

        <div className={'content-invisible'}>{iconRender}</div>
      </Flex>

      <Flex>
        <Checkbox
          padding
          label="Hide header"
          checked={widget.hideHeader}
          onChange={(checked) => onChangeField('hideHeader', checked)}
        />
        <Checkbox
          padding
          label="Enable full screen"
          disabled={widget.hideHeader}
          checked={widget.allowWindowMode}
          onChange={(checked) => {
            onChangeField('allowWindowMode', checked)
          }}
        />
        {/* TODO: delete? */}
        {/*<Checkbox*/}
        {/*  padding*/}
        {/*  disabled={widget.hideHeader}*/}
        {/*  label="Enable Scaling"*/}
        {/*  checked={widget.isScalable}*/}
        {/*  onChange={(checked) => onChangeField('isScalable', checked)}*/}
        {/*/>*/}
      </Flex>

      <MultiSelect
        caption={'label'}
        source={rolesCrud}
        value={widget.roleIds || []}
        onChange={(value: any) => onChangeField('roleIds', value)}
        label={'Roles'}
      />

      <Input
        label="Description"
        value={widget.description}
        onChange={(value: string) => onChangeField('description', value)}
      />

      {renderCustomSettingsWidget
        ? renderCustomSettingsWidget({
            tab: 'baseSettings',
            widget: widget,
            onChangeField: onChangeField,
          })
        : null}
    </Flex>
  )
}
